<template>
<div class="box2">
  <router-link :to="{path:'/'+pathName}">
    <div class="box2Tit">
      <span>{{title}}</span>
      <img src="@/assets/img/plant/line2.png"  class="line2"/>
      <div class="box2TitLine"></div>
      <img src="@/assets/img/jiantou2.gif" v-if="isImg" class="isImg" />
    </div>
  </router-link>
    <slot></slot>
</div>
</template>
<script>
import { ref, onMounted } from "vue";

export default {
  name: "baseBar",
  props: ["title","isImg","pathName"],
  setup(props) {

    onMounted(() => {
     
      
    });
    return {
      
    };
  },
};

</script>
<style lang="less" scoped>
 .box2{
    width: 503px;
    flex: 1;
    background: rgba(7,93,79,.2);
    display: flex;
    flex-direction: column;
    .box2Tit{
      padding:  10px 0 10px 15px;
      position: relative;
      overflow: hidden;
      text-align: left;
      box-sizing: border-box;
      position: relative;
      span{
        display: block;
        font-size: 18px;
        font-weight: bold;
        background: linear-gradient( to top, #1DD2BA 0%, #1DD2BA 30%, #fff 99%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .box2TitLine{
        width: 50px;
        height: 2px;
        background: #15A490;
        position: absolute;
        bottom: 0;
        animation: box2TitLine 2s linear infinite;
      }
      .line2{
        width: 100%;
        height: 5px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      .isImg{
        height: 16px;
        position: absolute;
        right: 16px;
        top: 13px;
      }
    }
    }
    
@keyframes box2TitLine {
    0% {
        left: 0%;
    }

    50%,
    100% {
        left: 100%;
    }
}
</style>
